import React from 'react'
import PropTypes from 'prop-types'
import { Pane, Stack, Portal, StackingOrder } from 'evergreen-ui'

/**
 * A component that overlays it children over the current page.
 * It does not provide any UI.
 *
 * The FullscreenModal is rendered inside of a Portal and uses the
 * Stack component to properly manage the z-index of its children.

 * This component also disabled scrolling on the body.
 */
export default class FullscreenModal extends React.PureComponent {
  static propTypes = {
    ...Pane.propTypes,
    children: PropTypes.node
  }

  static defaultProps = {
    background: 'tint2'
  }

  componentDidMount() {
    document.body.style.overflow = 'hidden'
  }

  componentWillUnmount() {
    document.body.style.overflow = null
  }

  render() {
    const { background, children, ...paneProps } = this.props
    return (
      <Portal>
        <Stack value={StackingOrder.OVERLAY}>
          {zIndex => (
            <Pane
              zIndex={zIndex}
              background={background}
              position="fixed"
              top={0}
              left={0}
              right={0}
              bottom={0}
              {...paneProps}
            >
              {children}
            </Pane>
          )}
        </Stack>
      </Portal>
    )
  }
}
